module.exports = __webpack_public_path__ + "static/media/mbs_3.1ae67211.jpg";